<template>
  <div class="dialog_box">
    <el-dialog title="处理意见" :visible="show" width="437px" @close="dialogClose" top="20vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <el-form ref="form" class="form_box" :model="form" label-width="110px" :rules="rules">
          <el-form-item label="处理人员">
            <el-input placeholder="默认当前账号为处理人员" disabled></el-input>
          </el-form-item>
          <el-form-item label="处理状态" prop="isPass">
            <el-radio v-model="form.isPass" :label="true">通过</el-radio>
            <el-radio v-model="form.isPass" :label="false">驳回</el-radio>
          </el-form-item>
          <el-form-item label="处理结果" prop="solveType">
            <el-select v-model="form.solveType" placeholder="请选择处理结果">
              <el-option v-for="item in solveTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" :prop="form.isPass ? '' : 'reason'">
            <el-input v-model="form.reason" type="textarea" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      form: {
        solveType: null,
        targetUserId: null,
        isPass: null,
        reason: "",
        orderId: 0,
      },
      rules: {
        isPass: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        reason: [{ required: true, message: "请输入备注", trigger: "bulur" }],
        solveType: [
          { required: true, message: "请选择处理结果", trigger: "change" },
        ],
        targetUserId: [
          { required: true, message: "请选择处理人员", trigger: "change" },
        ],
      },
      headers: {},
      solveTypeList: [],
      userList: [],
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    show (val) {
      if (val) {
      }
    },
  },
  created () {
    this.headers = {
      Authorization: sessionStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };

    this.$http.queryDist({ type: "意见处理结果类型" }).then((res) => {
      if (res.code === 0) {
        this.solveTypeList = res.data;
      } else {
        this.solveTypeList = [];
      }
    });
  },
  methods: {
    dialogClose () {
      this.$emit("update:show", false);
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.form.orderId = this.data.id;
        this.$http.processAdvice(this.form).then((res) => {
          if (res.code === 0) {
            this.form = {};
            this.$parent.getList();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-dialog__body {
  overflow-y: visible !important;
}

.upload_img {
  width: 240px;
  height: 172px;
  margin-bottom: 20px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/feedback/component/dispose.vue